<div class="expanded-details">
  <div class="first-row">
    <div class="jobseeker-stats">
      <div>
        <div>
          <strong>{{ 'label.ID' | translate }}: </strong>
          <span class="announcement-id-value">{{
            jobseekerDetails?.jobseekerId
          }}</span>
        </div>
      </div>
      <div>
        <div>
          <strong>{{ 'label.Privacy' | translate }}: </strong>
          <span>{{ jobseekerDetails?.jobseekerPrivacyName }}</span>
        </div>
      </div>
    </div>
    <div
      class="delete-jobseeker"
      *ngIf="jobseekerDetails?.isInitialModerationPassed"
    >
      <button
        type="button"
        (click)="onJobseekerDelete(jobseekerDetails?.jobseekerId)"
      >
        <svg-icon src="assets/img/delete_jobseeker.svg"></svg-icon>
        {{ 'label.Delete' | translate }}
      </button>
    </div>
  </div>
  <div class="second-row">
    <div>
      <div>
        <strong>{{ 'label.ApplicationInformation' | translate }}: </strong>
        <span>{{ jobseekerDetails?.announcementApplicationCount }}</span>
      </div>
    </div>
    <div>
      <div>
        <strong>{{ 'label.NumberOfCvBoxesAppliedTo' | translate }}: </strong>
        <span>{{ jobseekerDetails?.cvBoxApplicationCount }} </span>
      </div>
    </div>
    <div>
      <strong>{{ 'label.RegistrationDate' | translate }}: </strong>
      <span *ngIf="jobseekerDetails?.registrationDate">{{
        jobseekerDetails?.registrationDate | date : 'dd/MM/yy h:mm a'
      }}</span>
      <span *ngIf="!jobseekerDetails?.registrationDate">N/A</span>
    </div>
    <div>
      <strong>{{ 'label.LastLoginDate' | translate }}: </strong>
      <span *ngIf="jobseekerDetails?.lastVisitDate">{{
        jobseekerDetails?.lastVisitDate | date : 'dd/MM/yy h:mm a'
      }}</span>
      <span *ngIf="!jobseekerDetails?.lastVisitDate">N/A</span>
    </div>
    <div>
      <strong>{{ 'label.LastChangeDate' | translate }}: </strong>
      <span *ngIf="jobseekerDetails?.lastChangeDate">{{
        jobseekerDetails?.lastChangeDate | date : 'dd/MM/yy h:mm a'
      }}</span>
      <span *ngIf="!jobseekerDetails?.lastChangeDate">N/A</span>
    </div>
  </div>
  <div class="third-row">
    <div *ngIf="jobseekerDetails?.moderationChangeLogItems.length > 0">
      <strong
        >{{
          ('label.Logs' | translate) +
            '(' +
            jobseekerDetails?.moderationChangeLogItems.length +
            ')'
        }}:
      </strong>
      <div
        *ngFor="
          let log of jobseekerDetails?.moderationChangeLogItems | slice : -2
        "
      >
        <div class="create-user">
          {{ log.createUserFullName }}:
          <span>{{ log.createDate | date : 'dd/MM/yy' }}</span>
        </div>
        <div
          class="process-user"
          [ngStyle]="{ color: getLogColor(log.status) }"
        >
          {{ log.processUserFullName }}:
          <span>{{ log.processDate | date : 'dd/MM/yy' }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="fourth-row">
    <div class="activation-link">
      <div class="activation-link-input">
        <strong>{{ 'label.ActivationLink' | translate }}</strong>
        <div #activationLink class="activation-link-label">
          {{
            jobseekerDetails?.activationLink
              ? jobseekerDetails?.activationLink
              : ''
          }}
        </div>
      </div>
      <button
        class="mybtn"
        (click)="
          copyText(overlayPanel, $event, jobseekerDetails?.activationLink)
        "
      >
        <svg-icon src="assets/img/activation-link.svg"></svg-icon>
      </button>
    </div>
    <div class="reset-password">
      <div #op2 class="reset-password-label">{{ resetPassword }}</div>
      <button (click)="onResetPasswordClick()" class="mybtn">
        <svg-icon src="assets/img/reset_password.svg"></svg-icon>
      </button>
    </div>
    <div class="login">
      <a [href]="jobseekerProfile" target="_blank"
        >{{ 'label.Login' | translate }}
        <svg-icon src="assets/img/login_as_admin.svg"></svg-icon
      ></a>
    </div>
    <p-overlayPanel #overlayPanel>{{
      'label.CopiedSuccessfully' | translate
    }}</p-overlayPanel>
  </div>
</div>
